import { createReducer, on } from '@ngrx/store';
import { setLocationSearchText } from './locations.actions';

export interface ILocationsReducerState {
	searchText: string;
}

export const initialState: ILocationsReducerState = {
	searchText: '',
};

export const locationsReducer = createReducer(
	initialState,
	on(setLocationSearchText, (state, { searchText }) => ({ ...state, searchText }))
);
